// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perxis-auto-1_18_1-price {
  /* Typography */
  --perxis-auto-price-title-font-family-inner: var(--perxis-auto-price-title-font-family, var(--perxis-auto-root-typography-small-font-family-inner));
  --perxis-auto-price-title-font-size-inner: var(--perxis-auto-price-title-font-size, var(--perxis-auto-root-typography-small-font-size-xxl-inner));
  --perxis-auto-price-title-font-weight-inner: var(--perxis-auto-price-title-font-weight, var(--perxis-auto-root-typography-small-font-weight-inner));
  --perxis-auto-price-title-letter-spacing-inner: var(--perxis-auto-price-title-letter-spacing, var(--perxis-auto-root-typography-small-letter-spacing-inner));
  --perxis-auto-price-title-line-height-inner: var(--perxis-auto-price-title-line-height, var(--perxis-auto-root-typography-small-line-height-xxl-inner));
  --perxis-auto-price-title-text-transform-inner: var(--perxis-auto-price-title-text-transform, none);
  --perxis-auto-price-current-font-family-inner: var(--perxis-auto-price-current-font-family, var(--perxis-auto-root-typography-h3-font-family-inner));
  --perxis-auto-price-current-font-size-inner: var(--perxis-auto-price-current-font-size, var(--perxis-auto-root-typography-h3-font-size-xxl-inner));
  --perxis-auto-price-current-font-weight-inner: var(--perxis-auto-price-current-font-weight, var(--perxis-auto-root-typography-h3-font-weight-inner));
  --perxis-auto-price-current-letter-spacing-inner: var(--perxis-auto-price-current-letter-spacing, var(--perxis-auto-root-typography-h3-letter-spacing-inner));
  --perxis-auto-price-current-line-height-inner: var(--perxis-auto-price-current-line-height, var(--perxis-auto-root-typography-h3-line-height-xxl-inner));
  --perxis-auto-price-current-text-transform-inner: var(--perxis-auto-price-current-text-transform, none);
  --perxis-auto-price-current-color-inner: var(--perxis-auto-price-current-color, var(--perxis-auto-typography-color-darkest-inner));
  --perxis-auto-price-old-font-family-inner: var(--perxis-auto-price-old-font-family, var(--perxis-auto-root-typography-super-small-font-family-inner));
  --perxis-auto-price-old-font-size-inner: var(--perxis-auto-price-old-font-size, var(--perxis-auto-root-typography-super-small-font-size-xxl-inner));
  --perxis-auto-price-old-font-weight-inner: var(--perxis-auto-price-old-font-weight, var(--perxis-auto-root-typography-super-small-font-weight-inner));
  --perxis-auto-price-old-letter-spacing-inner: var(--perxis-auto-price-old-letter-spacing, var(--perxis-auto-root-typography-super-small-letter-spacing-inner));
  --perxis-auto-price-old-line-height-inner: var(--perxis-auto-price-old-line-height, var(--perxis-auto-root-typography-super-small-line-height-xxl-inner));
  --perxis-auto-price-old-text-transform-inner: var(--perxis-auto-price-old-text-transform, none);
  --perxis-auto-price-old-text-decoration-inner: var(--perxis-auto-price-old-text-decoration, line-through);
  --perxis-auto-price-old-color-inner: var(--perxis-auto-price-old-color, var(--perxis-auto-root-fifth-color-inner));
  /* End Typography */
}
.perxis-auto-1_18_1-price.perxis-auto-1_18_1-price--old-value-bottom .perxis-auto-1_18_1-price__content {
  display: block;
}
.perxis-auto-1_18_1-price.perxis-auto-1_18_1-price--old-value-bottom .perxis-auto-1_18_1-price__content .perxis-auto-1_18_1-price__current {
  display: inline-block;
  vertical-align: middle;
  padding-right: 8px;
}
.perxis-auto-1_18_1-price.perxis-auto-1_18_1-price--old-value-bottom .perxis-auto-1_18_1-price__content .perxis-auto-1_18_1-price__extra {
  display: inline-flex;
  vertical-align: middle;
  padding-right: 8px;
}
.perxis-auto-1_18_1-price.perxis-auto-1_18_1-price--old-value-right .perxis-auto-1_18_1-price__content {
  display: flex;
  align-items: center;
  gap: 8px;
}
.perxis-auto-1_18_1-price.perxis-auto-1_18_1-price--old-value-right .perxis-auto-1_18_1-price__content .perxis-auto-1_18_1-price__extra {
  display: flex;
  justify-content: center;
  align-items: center;
}
.perxis-auto-1_18_1-price.perxis-auto-1_18_1-price--old-value-right .perxis-auto-1_18_1-price__content .perxis-auto-1_18_1-price__old {
  display: inline-flex;
}
.perxis-auto-1_18_1-price.perxis-auto-1_18_1-price--old-value-top .perxis-auto-1_18_1-price__content {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.perxis-auto-1_18_1-price.perxis-auto-1_18_1-price--old-value-top .perxis-auto-1_18_1-price__content .perxis-auto-1_18_1-price__current {
  display: inline-block;
  vertical-align: middle;
  padding-right: 8px;
}
.perxis-auto-1_18_1-price.perxis-auto-1_18_1-price--old-value-top .perxis-auto-1_18_1-price__content .perxis-auto-1_18_1-price__extra {
  display: inline-block;
  vertical-align: middle;
  padding-right: 8px;
}
.perxis-auto-1_18_1-price.perxis-auto-1_18_1-price--old-value-top .perxis-auto-1_18_1-price__content .perxis-auto-1_18_1-price__old {
  order: -1;
  flex: 0 0 100%;
}
.perxis-auto-1_18_1-price__title {
  --perxis-auto-typography-main-font-family: var(--perxis-auto-price-title-font-family-inner);
  --perxis-auto-typography-main-font-weight: var(--perxis-auto-price-title-font-weight-inner);
  --perxis-auto-typography-main-letter-spacing: var(--perxis-auto-price-title-letter-spacing-inner);
  --perxis-auto-typography-main-text-transform: var(--perxis-auto-price-title-text-transform-inner);
  --perxis-auto-typography-main-font-size-xxs: var(--perxis-auto-price-title-font-size-inner);
  --perxis-auto-typography-main-font-size-xs: var(--perxis-auto-price-title-font-size-inner);
  --perxis-auto-typography-main-font-size-sm: var(--perxis-auto-price-title-font-size-inner);
  --perxis-auto-typography-main-font-size-md: var(--perxis-auto-price-title-font-size-inner);
  --perxis-auto-typography-main-font-size-lg: var(--perxis-auto-price-title-font-size-inner);
  --perxis-auto-typography-main-font-size-xl: var(--perxis-auto-price-title-font-size-inner);
  --perxis-auto-typography-main-font-size-xxl: var(--perxis-auto-price-title-font-size-inner);
  --perxis-auto-typography-main-line-height-xxs: var(--perxis-auto-price-title-line-height-inner);
  --perxis-auto-typography-main-line-height-xs: var(--perxis-auto-price-title-line-height-inner);
  --perxis-auto-typography-main-line-height-sm: var(--perxis-auto-price-title-line-height-inner);
  --perxis-auto-typography-main-line-height-md: var(--perxis-auto-price-title-line-height-inner);
  --perxis-auto-typography-main-line-height-lg: var(--perxis-auto-price-title-line-height-inner);
  --perxis-auto-typography-main-line-height-xl: var(--perxis-auto-price-title-line-height-inner);
  --perxis-auto-typography-main-line-height-xxl: var(--perxis-auto-price-title-line-height-inner);
}
.perxis-auto-1_18_1-price__title.ant-5_24_1-typography.perxis-auto-1_18_1-typography.perxis-auto-1_18_1-text {
  display: inline-block;
  margin-bottom: var(--perxis-auto-gap-vertical-purple-inner);
}
.perxis-auto-1_18_1-price__current-value {
  --perxis-auto-typography-main-font-family: var(--perxis-auto-price-current-font-family-inner);
  --perxis-auto-typography-main-font-weight: var(--perxis-auto-price-current-font-weight-inner);
  --perxis-auto-typography-main-letter-spacing: var(--perxis-auto-price-current-letter-spacing-inner);
  --perxis-auto-typography-main-text-transform: var(--perxis-auto-price-current-text-transform-inner);
  --perxis-auto-typography-color-darkest: var(--perxis-auto-price-current-color-inner);
  --perxis-auto-typography-main-font-size-xxs: var(--perxis-auto-price-current-font-size-inner);
  --perxis-auto-typography-main-font-size-xs: var(--perxis-auto-price-current-font-size-inner);
  --perxis-auto-typography-main-font-size-sm: var(--perxis-auto-price-current-font-size-inner);
  --perxis-auto-typography-main-font-size-md: var(--perxis-auto-price-current-font-size-inner);
  --perxis-auto-typography-main-font-size-lg: var(--perxis-auto-price-current-font-size-inner);
  --perxis-auto-typography-main-font-size-xl: var(--perxis-auto-price-current-font-size-inner);
  --perxis-auto-typography-main-font-size-xxl: var(--perxis-auto-price-current-font-size-inner);
  --perxis-auto-typography-main-line-height-xxs: var(--perxis-auto-price-current-line-height-inner);
  --perxis-auto-typography-main-line-height-xs: var(--perxis-auto-price-current-line-height-inner);
  --perxis-auto-typography-main-line-height-sm: var(--perxis-auto-price-current-line-height-inner);
  --perxis-auto-typography-main-line-height-md: var(--perxis-auto-price-current-line-height-inner);
  --perxis-auto-typography-main-line-height-lg: var(--perxis-auto-price-current-line-height-inner);
  --perxis-auto-typography-main-line-height-xl: var(--perxis-auto-price-current-line-height-inner);
  --perxis-auto-typography-main-line-height-xxl: var(--perxis-auto-price-current-line-height-inner);
}
.perxis-auto-1_18_1-price__current .ant-5_24_1-statistic-content {
  display: inline-flex;
}
.perxis-auto-1_18_1-price__current .ant-5_24_1-statistic-content-value {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  font-weight: inherit;
  text-transform: inherit;
  letter-spacing: inherit;
  color: inherit;
}
.perxis-auto-1_18_1-price__old-value {
  --perxis-auto-typography-super-small-font-family: var(--perxis-auto-price-old-font-family-inner);
  --perxis-auto-typography-super-small-font-weight: var(--perxis-auto-price-old-font-weight-inner);
  --perxis-auto-typography-super-small-letter-spacing: var(--perxis-auto-price-old-letter-spacing-inner);
  --perxis-auto-typography-super-small-text-transform: var(--perxis-auto-price-old-text-transform-inner);
  --perxis-auto-typography-color-dark-light: var(--perxis-auto-price-old-color-inner);
  --perxis-auto-typography-super-small-font-size-xxs: var(--perxis-auto-price-old-font-size-inner);
  --perxis-auto-typography-super-small-font-size-xs: var(--perxis-auto-price-old-font-size-inner);
  --perxis-auto-typography-super-small-font-size-sm: var(--perxis-auto-price-old-font-size-inner);
  --perxis-auto-typography-super-small-font-size-md: var(--perxis-auto-price-old-font-size-inner);
  --perxis-auto-typography-super-small-font-size-lg: var(--perxis-auto-price-old-font-size-inner);
  --perxis-auto-typography-super-small-font-size-xl: var(--perxis-auto-price-old-font-size-inner);
  --perxis-auto-typography-super-small-font-size-xxl: var(--perxis-auto-price-old-font-size-inner);
  --perxis-auto-typography-super-small-line-height-xxs: var(--perxis-auto-price-old-line-height-inner);
  --perxis-auto-typography-super-small-line-height-xs: var(--perxis-auto-price-old-line-height-inner);
  --perxis-auto-typography-super-small-line-height-sm: var(--perxis-auto-price-old-line-height-inner);
  --perxis-auto-typography-super-small-line-height-md: var(--perxis-auto-price-old-line-height-inner);
  --perxis-auto-typography-super-small-line-height-lg: var(--perxis-auto-price-old-line-height-inner);
  --perxis-auto-typography-super-small-line-height-xl: var(--perxis-auto-price-old-line-height-inner);
  --perxis-auto-typography-super-small-line-height-xxl: var(--perxis-auto-price-old-line-height-inner);
}
.perxis-auto-1_18_1-price__old .ant-5_24_1-statistic-content {
  display: inline-flex;
}
.perxis-auto-1_18_1-price__old .ant-5_24_1-statistic-content-value {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  font-weight: inherit;
  text-transform: inherit;
  text-decoration: var(--perxis-auto-price-old-text-decoration-inner);
  letter-spacing: inherit;
  color: inherit;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
